import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { empModulo } from '../../diccionarios/empModulo';
import { EmpresasModel } from '../../models/empresasModel';

@Injectable({
  providedIn: 'root'
})
export class ReportesService {

  diccionarioUrl: any;
  urlEmpTerceros: string;
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlEmpTerceros = this.utilServices.getNomina();
    this.diccionarioUrl = empModulo.url.epp.administrador;
  }

  getReporteByCed(cedula: string){
    return this.commom.peticionGetConHeader(this.urlEmpTerceros + this.diccionarioUrl.getReportUsers +'/'+ cedula);
  }

  getReporteExcelHistorico(){
    return this.commom.peticionGetConHeader(this.urlEmpTerceros + this.diccionarioUrl.getReportusresExcel);
  }

  getReportEmpleados(){
    return this.commom.peticionGetConHeader(this.urlEmpTerceros + this.diccionarioUrl.getReportEmploye);
  }

  getReporteEmpleadosExcel(){
    return this.commom.peticionGetConHeader(this.urlEmpTerceros + this.diccionarioUrl.getReportEmployeExcel);
  }

  getAllEmpresas() {//: Observable<DatosColaboradores> {
    return this.commom.peticionGetConHeader(this.urlEmpTerceros + this.diccionarioUrl.getEmpresas);
  }

  postEmpresas(empresas : EmpresasModel) {//: Observable<DatosColaboradores> {
    return this.commom.peticionPostConHeader(this.urlEmpTerceros + this.diccionarioUrl.getEmpresas, empresas);
  }

  deleteEmpresa(codEmpresa : string){
    return this.commom.peticionDeleteConHeader(this.urlEmpTerceros + this.diccionarioUrl.getEmpresas+"/"+codEmpresa);
  }

  anularHistorial(empleadoPk) {
    return this.commom.peticionPutConHeader(this.urlEmpTerceros + this.diccionarioUrl.anularHistorial, empleadoPk);
  }


}